import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core'
import { IS_PLATFORM_SERVER } from '@upkey-platform/core/core-data-access'
import { SEOHelper } from '@upkey-platform/utils/utils-shared'
import { SeoSocialShareService } from 'ngx-seo'
import {
  CAREER_CREATION_SECTION,
  CAREER_RESOURCE,
  CHROME_EXTENSION_SECTION,
  FAQS,
  HOME_TESTIMONIALS,
  JOB_INTERNSHIP_SECTION,
  SELF_BRANDING_SECTION
} from '../../../core/constants/home-widget.constants'
import { PublicPaths } from '../public-route-names'

@Component({
  selector: 'u-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeScreenComponent implements OnInit {
  comments = HOME_TESTIMONIALS
  careerSection = CAREER_CREATION_SECTION
  careerResourceSection = CAREER_RESOURCE
  selfBrandingSection = SELF_BRANDING_SECTION
  internshipSection = JOB_INTERNSHIP_SECTION
  chromeExtensionSection = CHROME_EXTENSION_SECTION
  jobsRoute = PublicPaths.JobsPagePath
  cccRoute = PublicPaths.CCCPagePath
  sbcRoute = PublicPaths.SelfBrandingCoursePath
  @ViewChild('career', { static: false }) career: ElementRef
  chromeExtensionURL = 'https://chrome.google.com/webstore/detail/upkey/dkmnopepcjbpbjemodknnjbhhapecikb'
  readonly faqs = FAQS

  constructor(
    @Inject(IS_PLATFORM_SERVER) private isServer: boolean,
    private seoSocialShareService: SeoSocialShareService
  ) {}

  ngOnInit(): void {
    this.seoSocialShareService.setData({
      title: SEOHelper.metaTitle('Career Creation Platform'),
      type: 'website',
      description:
        'Free career tools to help you craft a perfect resume in minutes and career resources to set you up for success!',
      image: SEOHelper.metaImage('/assets/images/meta/upkey-new-homepage.jpeg'),
      imageAuxData: {
        secureUrl: SEOHelper.metaImage('/assets/images/meta/upkey-new-homepage.jpeg'),
        width: 1200,
        height: 627
      }
    })
  }
}
